// extracted by css-extract-rspack-plugin
export default {"Box":"column-frame-module__Box__Lwsm5","Box_1":"column-frame-module__Box_1__PQeok"};